<template>
  <LayoutDashboard title="Pós-Venda">
    <v-card outlined>
      <v-card-title>
        <!-- <v-btn color="primary" outlined @click="cadastrarPosVenda()"
          >Cadastrar</v-btn
        > -->
        <v-spacer></v-spacer>
        <h3>Registros: {{ getPosVendas.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getPosVendas.current_page"
          :length="getPosVendas.last_page"
          @input="listarPosVendas({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">#</th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.vendaId"
                    outlined
                    dense
                    label="Código Venda"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.cliente"
                    outlined
                    dense
                    label="Cliente"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.proximo_contato"
                    outlined
                    dense
                    label="Próximo Contato"
                    class="mt-2"
                    type="date"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-select
                    :items="['', 'EM ABERTO', 'FINALIZADO']"
                    v-model="dataPagina.status"
                    label="Status"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th width="10%" align="center">
                  <v-select
                    outlined
                    label="Exibir"
                    dense
                    :items="[10, 20, 30, 40, 50]"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="listarPosVendas({ ...dataPagina })"
                    class="mt-2"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in getPosVendas.data" :key="p.id">
                <td>{{p.id}}</td>
                <td align="center">{{ p.venda_id }}</td>
                <td>{{ p.venda.cliente ? p.venda.cliente.nome : '' }}</td>
                <td align="center">{{ $helper.formatDate(p.proximo_contato) }}</td>
                <td>{{p.status}}</td>
                <td align="center">
                  <TooltipButton
                    @click.native="visualizar(p)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-pos-venda-crm')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
    <!-- <ModalCadastro /> -->
    <ModalVisualizarVenda />
    <ModalVisualizar />

    
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalVisualizarVenda from "@/pages/venda/ModalVisualizar"
import ModalVisualizar from "@/pages/crm/posVenda/ModalVisualizar"
import PosVendaAtividadeService from "@/services/PosVendaAtividadeService"
// import ModalCadastro from "@/pages/crm/posVenda/ModalCadastro";
var _ = require("lodash");

export default {
  components: {
    // ModalCadastro,
    ModalVisualizarVenda,
    ModalVisualizar
  },
  data() {
    return {
      dataPagina: {
        id: "",
        vendaId: "",
        cliente: "",
        proximo_contato: "",
        status: "",
        // funcionaio_id: "",
        page: "",
        limit: 20,
      },
    };
  },
  computed: {
    ...mapGetters(["getPosVendas"]),
  },
  methods: {
    ...mapActions(["cadastrarPosVenda", "listarPosVendas", "visualizarPosVenda", "setModalAtualizarTabelaPosVenda", "visualizarVenda"]),
    pesquisar() {
      this.listarPosVendas(this.dataPagina);
    },
    visualizar(posVenda){
      this.visualizarPosVenda(posVenda)
      .then(res => {
        PosVendaAtividadeService.listar({...posVenda})
        .then(res => {
          this.$store.commit('setAtividadesPosVenda', res.data)
        })
        .catch(e => {
          console.log(e)
        })
      })
      .catch(e => console.log(e))
    }
  },
  created() {
    this.listarPosVendas(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>